export default {
  setColumnData(state, columnData) {
    state.columnData = columnData
  },
  setBanner(state, banner) {
    state.banner = banner
  },
  setOrderList(state, orderList) {
    state.orderList = orderList
  }
}
